/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  ResourceLibrary,
  ResourceLibraryFromJSON,
  ResourceLibraryFromJSONTyped,
  ResourceLibraryToJSON,
} from "./";

/**
 *
 * @export
 * @interface ResourceLibraryIEnumerableControllerResponse
 */
export interface ResourceLibraryIEnumerableControllerResponse {
  /**
   *
   * @type {Array<ResourceLibrary>}
   * @memberof ResourceLibraryIEnumerableControllerResponse
   */
  data?: Array<ResourceLibrary> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ResourceLibraryIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function ResourceLibraryIEnumerableControllerResponseFromJSON(
  json: any,
): ResourceLibraryIEnumerableControllerResponse {
  return ResourceLibraryIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function ResourceLibraryIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResourceLibraryIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(ResourceLibraryFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ResourceLibraryIEnumerableControllerResponseToJSON(
  value?: ResourceLibraryIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(ResourceLibraryToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
